export default {
  hero: {
    title: 'Quem Somos',
    subtitle:
      'Há 20 anos no mercado, somos uma consultoria estratégica de Inovação e Transformação Digital. Nossa especialidade é impulsionar negócios. Integramos tecnologia, pessoas e processos para melhorar os resultados dos nossos clientes.',
  },
}
